// extracted by mini-css-extract-plugin
export default {"content":"Account_content__kfYdz","tabs":"Account_tabs__vYoQc"};